function updateTabindex($elem, disabled) {
    $elem.tabIndex = disabled ? -1 : $elem.tabIndex < 0 ? 0 : $elem.tabIndex;
}

export { updateTabindex };
